import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { MatDialog } from '@angular/material';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from 'projects/bimbo/src/app/dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { Loan, PayrollParameters, Parameter, LoanParameters, Employee, PeriodTypeEnum, LoanStatus } from '@akiba/models_bimbo';
import { ValidatorFn, AbstractControl } from '@angular/forms';
import { environment } from 'projects/bimbo/src/environments/environment';
import * as moment from 'moment';

@Component({
  selector: 'app-rl-request',
  templateUrl: './rl-request.component.html',
  styleUrls: ['./rl-request.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RlRequestComponent implements OnInit, OnDestroy {

  textWage = '';
  variableLoan: boolean;
  newLoanType: boolean;
  //////////////////////////////////////
  payrollParameter: PayrollParameters | null = null;
  retirementSavingParameter: Parameter | null = null;
  retirementLoanParameter: LoanParameters | null = null;
  //////////////////////////////////////
  currentEmployee: Employee;
  //////////////////////////////////////
  newLoan: Loan = new Loan();
  requestedNumberOfPayments: number;
  requestedAmount: number;
  
  displayedUpFrontColumns: string[] = ['depositDateBiWeek', 'depositDateWeek', 'totalAmount'];
  displayedFixedColumns: string[] = ['biWeekNumber', 'weekNumber', 'year', 'capitalAmortization', 'capital', 'interest', 'totalAmount'];

  totalDebtAmount = 0;
  appLogicSubs: Subscription;
  @Input() contentLocation: AppState;
  constructor(public logicService: LogicService, public dialog: MatDialog, private dataService: DataSourceService) {

    this.variableLoan = environment.variableLoan;

    this.newLoan = new Loan();

    const parameters = this.logicService.dataManager.parameterDataLoader.parameters ? this.logicService.dataManager.parameterDataLoader.parameters : [];
    const payrollParameters = this.logicService.dataManager.parameterDataLoader.payrolls ? this.logicService.dataManager.parameterDataLoader.payrolls : [];
    this.currentEmployee = this.logicService.dataManager.proxyDataLoader.employee ? this.logicService.dataManager.proxyDataLoader.employee : this.logicService.dataManager.principalDataLoader.employee;

    this.retirementSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.retirementSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));
   // const tempP = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.retirementSaving).find(e => e.loanParameterAppliesTo(this.currentEmployee));
    const temp = [this.retirementSavingParameter].find(e => e.loanParameterAppliesTo(this.currentEmployee));
   
    this.retirementLoanParameter = temp.applicableLoanParameter;
    this.payrollParameter = payrollParameters.find(e => e.payrollAppliesTo(this.currentEmployee));  
    

  }

  ngOnInit() {

    this.totalDebtAmount = this.currentEmployee.retirementSavingsLoan ? this.currentEmployee.totalRetirementDebt : 0;
    if (this.currentEmployee.workInformation.wage.wageName === 'CATORCENAL') {
      this.textWage = 'Catorcenal';
      this.displayedUpFrontColumns.splice(1, 1);
      this.displayedFixedColumns.splice(1, 1);
    } else {
      this.textWage = 'Semanal';
      this.displayedUpFrontColumns.splice(0, 1);
      this.displayedFixedColumns.splice(0, 1);
    }

  }

  get maxLoanAmount(): number {
    return this.retirementLoanParameter.maxLoanAmount(this.currentEmployee, this.logicService.shouldCalculateAVGWage(this.currentEmployee));
  }

  get loanInterest(): number {
    return this.retirementLoanParameter.loanInterest(this.currentEmployee);
  }

  get maxNumberOfPayments(): number {
    const maxPayments : number = this.retirementLoanParameter.maxNumberOfPayments(this.currentEmployee);

    if (this.retirementLoanParameter.dateMaxPayments) {
      const m1 = moment();
      const dateMaxPayments = this.retirementLoanParameter.dateMaxPayments.getTime();
      const nowMilSecs = m1.toDate().getTime();
      const nextPaymentsLimit = this.payrollParameter.payrollDatesForLoans.filter(pd => pd.active === true && pd.startDate.getTime() >= nowMilSecs && pd.startDate.getTime() <= dateMaxPayments);      

      if (nextPaymentsLimit.length >= maxPayments || nextPaymentsLimit.length == 0) {
        return maxPayments;
      } else {
        return nextPaymentsLimit.length;
      }
    } else {
      return maxPayments;
    }
  }

  get discountPerPayment(): number {
    return this.newLoan.requestedAmount && this.newLoan.requestedNumberOfPayments ? (this.newLoan.requestedAmount / this.newLoan.requestedNumberOfPayments) : 0;
  }

  calculate() {

    if (this.newLoan.requestedAmount === 0) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el monto sea mayor a 0',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedNumberOfPayments < 2) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el número de cuotas sea mayor a 1',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedNumberOfPayments > this.maxNumberOfPayments) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el número de cuotas sea menor al máximo número de cuotas',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedAmount > this.retirementLoanParameter.maxLoanAmount(this.currentEmployee, this.logicService.shouldCalculateAVGWage(this.currentEmployee))) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el monto a solicitar sea menor al monto máximo.',
          close: 'Aceptar'
        }
      });

      return;

    }

    const m1 = moment();
    const nowMilSecs = m1.toDate().getTime();
    const nextPayments = this.payrollParameter.payrollDatesForLoans.filter(pd => pd.active === true && pd.startDate.getTime() >= nowMilSecs);
    this.requestedAmount = this.newLoan.requestedAmount;
    this.newLoan.requestedNumberOfPayments = Math.trunc(this.newLoan.requestedNumberOfPayments);
    this.requestedNumberOfPayments = this.newLoan.requestedNumberOfPayments;
    this.newLoan = this.retirementLoanParameter.calculateLoan(environment.variableLoan, this.currentEmployee, this.newLoan.requestedNumberOfPayments, this.newLoan.requestedAmount, this.loanInterest, this.payrollParameter, nextPayments);
    this.newLoanType = this.newLoan.interestType === 'upFront' || this.newLoan.interestType === '' ? false : true;

    const thirtyPercentRule = (0.30 * this.currentEmployee.periodWage);
    const wageLiq = (0.30 * this.currentEmployee.wageLiquidity);
    const max: number = Math.max(thirtyPercentRule, wageLiq);

    if (max < this.discountPerPayment) {

      this.newLoan = new Loan();

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El monto de las cuotas a pagar excederían tu capacidad de pago, tu capacidad de pago por cuota es de: $ ' + max.toFixed(2),
          close: 'Aceptar'
        }
      });
      return;

    }

  }

  saveLoanRequest() {

    if (this.newLoan.requestedAmount !== this.requestedAmount || this.newLoan.requestedNumberOfPayments !== this.requestedNumberOfPayments) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Favor de validar que el monto y el numero de cuotas coincida con el calculado.',
          close: 'Aceptar'
        }
      });
      return;
    }

    if (this.newLoan.requestedAmount > this.retirementLoanParameter.maxLoanAmount(this.currentEmployee, this.logicService.shouldCalculateAVGWage(this.currentEmployee))) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el monto a solicitar sea menor al monto máximo.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedAmount === 0) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el monto sea mayor a 0',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.requestedNumberOfPayments < 2) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el número de cuotas sea mayor a 1',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.newLoan.scheduleDates.values().length < 2) {
      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Es necesario que el número de cuotas sea mayor a 1',
          close: 'Aceptar'
        }
      });

      return;

    }

    const dialogReaffirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: `Está seguro(a) que desea solicitar un préstamo a la Caja de Ahorro por un monto de $ ${this.newLoan.requestedAmount.toFixed(2)} pesos`,
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });
    dialogReaffirmation.afterClosed().subscribe(async result => {
      if (result) {

        this.newLoan.status = LoanStatus.REVIEW;

        this.newLoan.active = true;
        this.newLoan.typeID = '02';
        this.newLoan.type = 'retirement';
        this.newLoan.employeeRef.employeeNumber = this.currentEmployee.workInformation.employeeNumber;

        this.newLoan.employeeRef.uid = this.currentEmployee.uid;
        this.newLoan.employeeRef.email = this.currentEmployee.contactInformation.item('workEmail') ? this.currentEmployee.contactInformation.item('workEmail').value : '';
        this.newLoan.employeeRef.displayName = this.currentEmployee.displayName;
        

        if (this.currentEmployee.employeeSeniorityInYears >= 2) {
          this.newLoan.status = LoanStatus.ACTIVE;
        } else {
          // await this.dataService.updateNotifications(this.currentEmployee.workInformation.supervisor.employeeNumber, 1);
        }

        const activePeriod = this.retirementSavingParameter;
        if (activePeriod) {
          this.newLoan.periodId = activePeriod.parametersID;
        }

        const request = this.newLoan.toAny();
        const sd = this.newLoan.scheduleDates.toObject();
        request.companyID = this.currentEmployee.workInformation.companyRef.companyID;
        this.dataService.saveLoanRequest(request, sd).then(() => {
          this.newLoan = new Loan();
          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'Su solicitud se realizó con éxito.',
              close: 'Aceptar'
            }
          });

        }).catch(error => {

          this.dialog.open(InfoDialogComponent, {
            data: {
              message: 'No fue posible cancelar el ahorro, inténtelo mas tarde.',
              close: 'Aceptar'
            }
          });

        });
      }
    });

  }

  ////////////////////////////////////////////////////////

  currencyInputChanged(value: string) {

    const num = value.replace(/[$,]/g, '');
    const intValue = Number(num);
    return intValue;

  }

  customValidator(min: number, max: number): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

      let result: any | null = null;

      if (!control.value) {
        return result;
      }

      const num = control.value ? control.value.replace(/[$,]/g, '') : 0;
      const intValue = Number(num);

      if (isNaN(intValue)) {
        result = { min: true };
      } else if (intValue < min) {
        result = { min: true };
      } else if (intValue > max) {
        result = { max: true };
      }

      return result;

    };

  }

  ////////////////////////////////////////////////////////

  cancel(tabIndex: number, contentIndex: number | null) {
    const cancelRegistration = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Confirmar'
      }
    });

    cancelRegistration.afterClosed().subscribe(result => {
      if (result) {
        this.contentLocation.tabIndex = tabIndex;
        this.contentLocation.contentIndex = contentIndex;
        this.contentLocation.detailIndex = 0;
      }
    });
  }

  cancelSimple(tabIndex: number, contentIndex: number | null) {
    this.contentLocation.tabIndex = tabIndex;
    this.contentLocation.contentIndex = contentIndex;
    this.contentLocation.detailIndex = 0;
  }

  ngOnDestroy(): void {
    if (this.appLogicSubs && !this.appLogicSubs.closed) {
      this.appLogicSubs.unsubscribe();
      this.appLogicSubs = null;
    }
    this.newLoan = new Loan();
  }

}
